export const PAYER_DISTRIBUTION_MARGINS_MODAL_ID = "PAYER_DISTRIBUTION_MARGINS_MODAL" as const;
